var PhxCheckout = (function (PhxCheckout) {

    PhxCheckout.logger = function logger() {
        // Copied portions from eventRecorderSvc.js (Phx-web)
        // Fake up newrelic endpoints if not available, as in
        // Jasmine test environment... or if we haven't included
        // newrelic scripts.

        //Checks if console is available.
        function _hasConsole () {
            return (typeof console !== 'undefined' && typeof console.log !== 'undefined');
        }

        //_logDefault(): default / fallback (console) logger if NR is not enabled.
        function _logDefault(name, value) {
            if (_hasConsole())
                console.log('IFRAME EVENT [Name: ' + name + '] [ Value: ' + JSON.stringify(value) + ']');
        }

        //_logEventToServer(): if NR is enabled, it logs data to NR, else: local console.
        function _logEventToServer(name, values) {
          payload = {
              action: 'NRADDPAGEACTION',
              data: [name, values]
          };
          PhxCheckout.messenger.postMessageToParent(payload);
        }

        return {
            logEventToServer: _logEventToServer,
            logDefault: _logDefault,
            hasConsole: _hasConsole
        }
    }();

    return PhxCheckout;

}(PhxCheckout || {}));
